import React, { useEffect, useState } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow } from '@mui/material/';
import { Box } from '@mui/material';
import { EnhancedTableHead } from '../EnhancedTableHead';
import TableSkeleton from '../TableSkeleton';
import { sortData } from '../../common/SortSupport';
import { faCirclePlus, faEyeSlash, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ButtonDefault from '../ButtonDefault';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { formatDate, selectedProjectRegex, subGoalProjectDetailsRegex } from '../../common/StaticExports';
import StatusIndicatorSmall from '../StatusIndicatorSmall';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedProject } from '../../redux/reducers/actionPlan';
import { useLocation, useNavigate } from 'react-router';
import NestedThreeDotMenu from '../NestedThreeDotMenu';
import { archiveProject, deleteProject } from '../../api/projects';

const GoalProjectsTable = (props:any) => {

  const { data, isLoading, addProject, manageProjects } = props;
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedGoal = useSelector((state:any) => state.goalsAndStrategy.selectedGoal);
  const selectedSubGoal = useSelector((state:any) => state.goalsAndStrategy.selectedSubGoal);
  const [goal, setData] = useState(selectedGoal == null ? selectedSubGoal : selectedGoal);

  //supporting contents
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  let visibleRows = React.useMemo(
    () =>
      data && data.length > 0 &&
      sortData(data, orderBy, order),
    [order, orderBy, data],
  );

  const head = 
  [
    {
      key: 'name', displayName: 'project name',
    },
    {
      key: 'ragb', displayName: 'status',
    },
    {
      key: 'ownerName', displayName: 'owner',
    },
    {
      key: 'departmentName', displayName: 'department',
    },
    {
      key: 'dueDate', displayName: 'due date',
    },
    {
      key: '', displayName: '',
    },
  ];

  const threeDotMenuOptions =
  [
    {label: 'Archive Project', icon: faEyeSlash, isDisabled: false},
    {label: 'Delete Project', icon: faTrashCan, isDisabled: false},
  ];
  const handleThreedotMenuClick = async (selctedAction:any, project:any, index:any) => {
    switch(selctedAction) {
      case 'Delete Project':
        await deleteProject({ projectId: project?.id });
        manageProjects('deleteProject', project, index);
        break;
      case 'Archive Project':
        await archiveProject({ projectId: project?.id });
        manageProjects('archiveProject', project, index);
        break;
    }
  }
  const manageOnClick = (d:any) => {
    dispatch(setSelectedProject(d));
    navigate(`/goals/${goal?.id}/project/${d?.id}`);
  }

  useEffect(() => {
    if (selectedProjectRegex.test(location.pathname) || subGoalProjectDetailsRegex.test(location.pathname)) {
      const splitArr = location.pathname.split('/');
      const tempProjectId = splitArr[splitArr?.length - 1];
      if (data && data.length > 0) {
        const projectDetails = data.find((project:any) => project?.id.toString() === tempProjectId);
        if (projectDetails) {
          dispatch(setSelectedProject(projectDetails));
        }
      }
    }
  }, [location.pathname])

  //table contents
    return(
        <React.Fragment>
            <Box sx={{ position: 'relative' }}>
              <TableContainer 
              sx={{ 
                "& .MuiTable-root": {
                  border: 0,
                },
                "& .MuiTableCell-root": {
                  borderBottom: "none", // Remove bottom borders from table cells
                },
                "& .MuiTableRow-root": {
                  border: "none", // Remove row borders
                }
              }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    />
                    {
                      !isLoading && visibleRows.length ?
                      <TableBody>
                        {
                          visibleRows.map((d: any, i: number) => (
                            <>
                              <TableRow
                              className='hoverBG'
                              sx={{ cursor: 'pointer' }}
                              key={`tasks-table-row-${i}`}>
                                <TableCell className='fs12' width={'900px'} onClick={() => { manageOnClick(d) }}>
                                  {d?.name ? d?.name : ''}
                                </TableCell>
                                <TableCell sx={{ width: '130px' }} onClick={() => { manageOnClick(d) }}>
                                  {d?.ragb != null ? <StatusIndicatorSmall reportType ={'rabg'} status={d?.ragb} /> : '-'}
                                </TableCell>
                                <TableCell className='fs12' width={'900px'} onClick={() => { manageOnClick(d) }}>
                                  {d?.ownerName ? d?.ownerName : '-'}
                                </TableCell>
                                <TableCell sx={{ width: '130px' }} onClick={() => { manageOnClick(d) }}>
                                  {d?.departmentName ? d?.departmentName : ''}
                                </TableCell>
                                <TableCell className='fs12' width={'900px'} onClick={() => { manageOnClick(d) }}>
                                  {d?.dueDate ? formatDate(d?.dueDate) : '-'}
                                </TableCell>
                              <TableCell sx={{ width: '1px' }}>
                                <NestedThreeDotMenu options={threeDotMenuOptions} manageClick={(e:any) => {handleThreedotMenuClick(e, d, i)}} />
                              </TableCell>
                              </TableRow>
                            </>
                          ))
                        }
                      </TableBody>
                      :
                      (
                        !isLoading && (!visibleRows || visibleRows?.length === 0) ?
                        <TableBody>
                          <TableRow>{'No Records Found'}</TableRow>
                        </TableBody> :
                        <TableBody>
                          <TableSkeleton rowCount={4} cellCount={5} />
                        </TableBody>
                      )
                    }
                </Table>
              </TableContainer>
              <Box sx={{ mt: 2 }}>
                  <ButtonDefault
                  variant={'outlined'}
                  value={t('ADD_PROJECT')}
                  manageOnClick={() => {addProject()}}
                  icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                  />
              </Box>
            </Box>
        </React.Fragment>
    )
}

export default GoalProjectsTable;